import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FacilitatorRoutes, GamerRoutes } from '../../../config/routes/routeEnums'
import { LoadingPage } from '../../../components/LoadingPage'
import useAppState from '../../../hooks/useAppState'
import { isParticipantRole } from '../../organization/orgStateHelpers'

/**
 * CollaborationRedirectPage
 *
 * Intercepts legacy /collaboration navigation coming from Unity callbacks
 * and forwards the user to the appropriate dashboard based on their role.
 * Preserves query parameters (e.g. sessionId) when redirecting.
 */
const CollaborationRedirectPage: React.FC = () => {
  const { state } = useAppState()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!state.isAuthInitialized || !state.user?.id) {
      return
    }

    const targetRoute = isParticipantRole(state.user) ? GamerRoutes.DASHBOARD : FacilitatorRoutes.DASHBOARD

    navigate(
      {
        pathname: targetRoute,
        search: location.search
      },
      { replace: true }
    )
  }, [state.isAuthInitialized, state.user, location.search, navigate])

  return <LoadingPage />
}

export default CollaborationRedirectPage
